export const ross1000 = {
  title: "ROSS 1000 / Turismo5",
  subtitle: "Rilevazione dei flussi turistici — estadística regional",

  fields: {
    region: "Región",
    codice: "Código de estructura",
    codiceHint: "Código de la estructura asignado por la región (campo «codice»).",
    username: "Usuario",
    password: "Contraseña",
    passwordHint: "Credenciales del web service ROSS 1000 (las asigna la región / GIES).",
    prodotto: "Nombre del software",
    camereDisponibili: "Habitaciones disponibles",
    lettiDisponibili: "Camas disponibles",
    defaultTipoturismo: "Tipo de turismo (por defecto)",
    defaultMezzotrasporto: "Medio de transporte (por defecto)",
    useTestEndpoint: "Usar entorno de pruebas",
    endpointResolved: "Endpoint",
    keepBlank: "(dejar vacío para no cambiar)",
  },

  regionOptions: {
    sardegna: "Sardegna",
    lazio: "Lazio",
    veneto: "Veneto",
    emilia_romagna: "Emilia-Romagna",
    toscana: "Toscana",
    piemonte: "Piemonte",
    lombardia: "Lombardia",
    liguria: "Liguria",
    marche: "Marche",
    abruzzo: "Abruzzo",
    molise: "Molise",
    calabria: "Calabria",
    basilicata: "Basilicata",
  },

  actions: {
    saveAndVerify: "Guardar y verificar",
    updateCredentials: "Actualizar credenciales",
    verifyConnection: "Verificar conexión",
    saving: "Guardando...",
    verifying: "Verificando...",
  },

  status: {
    connectionOk: "Credenciales guardadas y conexión verificada correctamente.",
    connectionError: "Error de conexión. Verifica las credenciales ingresadas.",
    connectionPending: "Conexión aún no verificada. Pulsa «Verificar conexión» para confirmar.",
  },

  validation: {
    codiceRequired: "El código de estructura es obligatorio.",
    usernameRequired: "El usuario es obligatorio.",
    passwordRequired: "La contraseña es obligatoria.",
    capacityRequired: "Indica las habitaciones y camas disponibles.",
  },

  toasts: {
    saveSuccess: "Credenciales guardadas y conexión verificada correctamente.",
    saveWarning: "Credenciales guardadas, pero la conexión no pudo verificarse.",
    saveError: "No se pudieron guardar las credenciales.",
    testSuccess: "Conexión con ROSS 1000 verificada correctamente.",
    testError: "No se pudo verificar la conexión.",
    statusActive: "ROSS 1000 activado.",
    statusInactive: "ROSS 1000 desactivado.",
  },
};
